export const FETCHED_DATA_SUCCESS = 'FETCHED_DATA_SUCCESS';
export const LIST_REQUEST = 'LIST_REQUEST';
export const GET_FAILURE = 'GET_FAILURE';